
import {
  defineComponent,
  ref,
  onMounted,
  PropType,
  computed,
  watch,
} from "vue";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import stc from "string-to-color";
import inviteEventModel from "@/core/models/share/inviteEvent.interface";
import timelineRowHeaderModel from "@/core/models/share/timeline/rowHeader.interface";
import inviteAvailableTimeCountModel from "@/core/models/hoster/inviteAvailableTimeCount.interface";
import voteEventModel from "@/core/models/share/voteEvent.interface";

import { useStore } from "vuex";
import { Module, Actions, Getters } from "@/store/enums/homeEnums";
import {
  Module as HosterModule,
  Actions as HosterActions,
  Getters as HosterGetters,
} from "@/store/enums/hosterEnums";
import statusModel from "@/core/models/share/status.interface";
import { values } from "lodash";
import { SelectOption, useMessage } from 'naive-ui'
import { Construct } from '@vicons/ionicons5';

export default defineComponent({
  name: "hosterResponseModalCurrentStatus",
  props: {
    event: { type: Object as PropType<inviteEventModel | null> },
  },
  components: {   },
  setup(props: any, context: any) {
    const store = useStore();
    const loading = ref(true);
    
    const rowHeaders = computed<Array<timelineRowHeaderModel>>(
      () =>
        store.getters[HosterModule.desc + HosterGetters.TimelineRowHeaderList]
    );

    const userResponseSummary = computed<Array<inviteAvailableTimeCountModel>>(
      () =>
        store.getters[HosterModule.desc + HosterGetters.EventSchedularWithCount]
    );

    const eventResponse = computed<Array<voteEventModel>>(() =>
      store.getters[
      HosterModule.desc +
      HosterGetters.EventResponse
      ]
    );
    
    const data = ref<Array<any>>([])
    


    rowHeaders.value.forEach((eHeader: timelineRowHeaderModel) => {
      let result = eventResponse.value.filter((e: voteEventModel) => e.EventParticipantId == eHeader.Value)
      let res: any = {};
      res.Name = eHeader.Text;
      res.EventParticipantId = eHeader.Value;
      result.forEach((e: voteEventModel) => {
        res[e.EventScheduleId] = e.Status
      })
      data.value.push(res)
      
    })

    //Summary
    rowHeaders.value.forEach((eHeader: timelineRowHeaderModel, index: number) => {
      if (index == 0) {
        let result = eventResponse.value.filter((e: voteEventModel) => e.EventParticipantId == eHeader.Value)
        let res: any = {};
        res.Name = 'Total';
        res.EventParticipantId = eHeader.Value;
        result.forEach((e: voteEventModel) => {
          userResponseSummary.value.forEach((v: inviteAvailableTimeCountModel) => {
              if(e.EventScheduleId == v.EventScheduleId){
                res[e.EventScheduleId] = v.AgreeCount;
                
              }
          })
          
        });

        data.value.push(res)
      }
    })

    if (data.value.length!=0)
    {
      loading.value = false;
    }

    const dataformat = (e: inviteAvailableTimeCountModel) => {
      return dayjs( e.ScheduleStartUTCDateTime).format("MM/DD ddd HH:mm - ") + dayjs( e.ScheduleEndUTCDateTime).format("HH:mm");
    }
    
    const selectValue = ref<Array<string>>([]);
  
    const options = userResponseSummary.value.map((v: inviteAvailableTimeCountModel) => ({
      label: dayjs( v.ScheduleStartUTCDateTime).format("MM/DD ddd HH:mm - ") + dayjs( v.ScheduleEndUTCDateTime).format("HH:mm"),
      value: v.EventScheduleId,
    }))
    
    let filterTime = ref<Array<inviteAvailableTimeCountModel>>([])
    
    const onSelectAll = () => {
      filterTime.value = [];
      selectValue.value = [];
      userResponseSummary.value.forEach((e: inviteAvailableTimeCountModel) => {
        filterTime.value.push(
          {
            AgreeCount: e.AgreeCount,
            EventHeaderId: e.EventHeaderId,
            EventScheduleId: e.EventScheduleId,
            ScheduleStartUTCDateTime: e.ScheduleStartUTCDateTime,
            ScheduleEndUTCDateTime: e.ScheduleEndUTCDateTime,
          })
        selectValue.value.push(e.EventScheduleId)
      })
    }
    onSelectAll();

    const onClearAll = () => {
      filterTime.value = [];
      selectValue.value = [];
    }

    const handleUpdateValue = (value: Array<string>, option: SelectOption) => {
      filterTime.value = []
      value.forEach((v: string) => {
        userResponseSummary.value.forEach((e: inviteAvailableTimeCountModel) => 
        { 
          if(e.EventScheduleId == v){
            filterTime.value.push(
              {
                AgreeCount: e.AgreeCount,
                EventHeaderId: e.EventHeaderId,
                EventScheduleId: e.EventScheduleId,
                ScheduleStartUTCDateTime: e.ScheduleStartUTCDateTime,
                ScheduleEndUTCDateTime: e.ScheduleEndUTCDateTime,
              }
            )       
          }
        }
        );
      })}

    const rowClass = (data: any) => {
      return data.Name === "Total" ? 'row-bg' : undefined;
    };

    const stockClass = (data: any) => {
      return [
        {
          'total': data.Name === 'Total',
        }
      ];
    }

    return {
      rowHeaders,
      eventResponse,
      userResponseSummary,
      data,
      loading,
      dataformat,
      options,
      selectValue,
      handleUpdateValue,
      filterTime,
      onSelectAll,
      onClearAll,
      rowClass,
      stockClass
    };
  },
});
